import { createFileRoute } from '@tanstack/react-router';
import Loader from '../../../../../../components/shared/custom-components/Loader';
import ExchangeSettingsContainer from '../../../../../../components/source-management/exchanges/exchange-page/exchange-settings/ExchangeSettingsContainer';

export const Route = createFileRoute(
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: ExchangeSettingsContainer,
});
